export const breakpoints = {
  xs: 0,
  sm: 576,
  // Medium screen / tablet
  md: 768,
  // Large screen / desktop
  lg: 992,
  // Extra large screen / wide desktop
  xl: 1200
};



// WEBPACK FOOTER //
// ./src/components/Grid/breakpoints.js